import { render, staticRenderFns } from "./CallHistory.vue?vue&type=template&id=daa408a4&scoped=true"
import script from "./CallHistory.vue?vue&type=script&lang=js"
export * from "./CallHistory.vue?vue&type=script&lang=js"
import style0 from "./CallHistory.vue?vue&type=style&index=0&id=daa408a4&prod&scoped=true&lang=scss"
import style1 from "./CallHistory.vue?vue&type=style&index=1&id=daa408a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa408a4",
  null
  
)

export default component.exports